import { getPublicKey as u, getServerUrl as g, metaData as d, useUrlChangeListener as b } from "./analytics.js";
import { f as t } from "./index-d0ae5922.js";
import { B as p, Q as T } from "./index-d0ae5922.js";
import { f as G } from "./creditFigmaToken-9b4c3a39.js";
import { PageContext as C, PageProvider as S } from "./pageContext.js";
import { AnalyticsContext as y } from "./quantumAnalyticsContext.js";
import { ThemeContext as B, ThemeProvider as D, injectGlobalStyles as E, injectScript as I, useTheme as L } from "./themeProvider.js";
import { M as j, a as z, T as A, e as K, d as M, f as N, b as Q, p as R, c as O, z as q } from "./index-7ed1516c.js";
import "react";
import "react/jsx-runtime";
import "styled-components";
import "./index-e6249aa0.js";
import "./index-e9bdff4d.js";
import "@ucl/shared-icons";
const r = {
  categorical: [
    t.semantic.color.chart.default.strong,
    t.semantic.color.chart.fordBlue.strong,
    t.semantic.color.chart.neutral.subtle,
    t.semantic.color.chart.teal.strong,
    t.semantic.color.chart.caution.moderate,
    t.semantic.color.chart.magenta.moderate,
    t.semantic.color.chart.purple.strong,
    t.semantic.color.chart.danger.strongest
  ],
  blue: [
    t.semantic.color.chart.default.strongest,
    t.semantic.color.chart.default.strong,
    t.semantic.color.chart.default.moderate,
    t.semantic.color.chart.default.subtle,
    t.semantic.color.chart.default.subtlest
  ],
  gray: [
    t.semantic.color.chart.neutral.strongest,
    t.semantic.color.chart.neutral.strong,
    t.semantic.color.chart.neutral.moderate,
    t.semantic.color.chart.neutral.subtle,
    t.semantic.color.chart.neutral.subtlest
  ],
  grabber: [
    t.semantic.color.chart.fordGrabber.strongest,
    t.semantic.color.chart.fordGrabber.strong,
    t.semantic.color.chart.fordGrabber.moderate,
    t.semantic.color.chart.fordGrabber.subtle,
    t.semantic.color.chart.fordGrabber.subtlest
  ],
  red: [
    t.semantic.color.chart.danger.strongest,
    t.semantic.color.chart.danger.strong,
    t.semantic.color.chart.danger.moderate,
    t.semantic.color.chart.danger.subtle,
    t.semantic.color.chart.danger.subtlest
  ],
  orange: [
    t.semantic.color.chart.caution.strongest,
    t.semantic.color.chart.caution.strong,
    t.semantic.color.chart.caution.moderate,
    t.semantic.color.chart.caution.subtle,
    t.semantic.color.chart.caution.subtlest
  ],
  green: [
    t.semantic.color.chart.success.strongest,
    t.semantic.color.chart.success.strong,
    t.semantic.color.chart.success.moderate,
    t.semantic.color.chart.success.subtle,
    t.semantic.color.chart.success.subtlest
  ],
  teal: [
    t.semantic.color.chart.teal.strongest,
    t.semantic.color.chart.teal.strong,
    t.semantic.color.chart.teal.moderate,
    t.semantic.color.chart.teal.subtle,
    t.semantic.color.chart.teal.subtlest
  ],
  magenta: [
    t.semantic.color.chart.magenta.strongest,
    t.semantic.color.chart.magenta.strong,
    t.semantic.color.chart.magenta.moderate,
    t.semantic.color.chart.magenta.subtle,
    t.semantic.color.chart.magenta.subtlest
  ],
  purple: [
    t.semantic.color.chart.purple.strongest,
    t.semantic.color.chart.purple.strong,
    t.semantic.color.chart.purple.moderate,
    t.semantic.color.chart.purple.subtle,
    t.semantic.color.chart.purple.subtlest
  ],
  bad2good: [
    t.semantic.color.chart.neutral.strongest,
    t.semantic.color.chart.danger.strongest,
    t.semantic.color.chart.danger.strong,
    t.semantic.color.chart.caution.moderate,
    t.semantic.color.chart.teal.strong,
    t.semantic.color.chart.teal.moderate,
    t.semantic.color.chart.default.strong,
    t.semantic.color.chart.default.moderate
  ],
  good2bad: [
    t.semantic.color.chart.default.moderate,
    t.semantic.color.chart.default.strong,
    t.semantic.color.chart.teal.moderate,
    t.semantic.color.chart.teal.strong,
    t.semantic.color.chart.caution.moderate,
    t.semantic.color.chart.danger.strong,
    t.semantic.color.chart.danger.strongest,
    t.semantic.color.chart.neutral.strongest
  ],
  divergent: {
    P1: [
      t.semantic.color.chart.default.strongest,
      t.semantic.color.chart.default.strong,
      t.semantic.color.chart.default.moderate,
      t.semantic.color.chart.default.subtle,
      t.semantic.color.chart.default.subtlest,
      t.semantic.color.chart.caution.subtlest,
      t.semantic.color.chart.caution.subtle,
      t.semantic.color.chart.caution.moderate,
      t.semantic.color.chart.caution.strong,
      t.semantic.color.chart.caution.strongest
    ],
    P2: [
      t.semantic.color.chart.neutral.strongest,
      t.semantic.color.chart.neutral.strong,
      t.semantic.color.chart.neutral.moderate,
      t.semantic.color.chart.neutral.subtle,
      t.semantic.color.chart.neutral.subtlest,
      t.semantic.color.chart.teal.subtlest,
      t.semantic.color.chart.teal.subtle,
      t.semantic.color.chart.teal.moderate,
      t.semantic.color.chart.teal.strong,
      t.semantic.color.chart.teal.strongest
    ],
    P3: [
      t.semantic.color.chart.fordGrabber.strongest,
      t.semantic.color.chart.fordGrabber.strong,
      t.semantic.color.chart.fordGrabber.moderate,
      t.semantic.color.chart.fordGrabber.subtle,
      t.semantic.color.chart.fordGrabber.subtlest,
      t.semantic.color.chart.teal.subtlest,
      t.semantic.color.chart.teal.subtle,
      t.semantic.color.chart.teal.moderate,
      t.semantic.color.chart.teal.strong,
      t.semantic.color.chart.teal.strongest,
      t.semantic.color.chart.caution.strongest,
      t.semantic.color.chart.caution.strong,
      t.semantic.color.chart.caution.moderate,
      t.semantic.color.chart.caution.subtle,
      t.semantic.color.chart.caution.subtlest
    ]
  }
}, m = {
  light: r,
  dark: r
};
export {
  y as AnalyticsContext,
  p as BREAKPOINTS,
  j as Mode,
  C as PageContext,
  S as PageProvider,
  T as QUERIES,
  B as ThemeContext,
  z as ThemeName,
  D as ThemeProvider,
  A as Themes,
  m as chartColors,
  K as creditDarkThemes,
  M as creditLightThemes,
  N as creditThemes,
  G as fcds,
  t as fpds,
  u as getPublicKey,
  g as getServerUrl,
  E as injectGlobalStyles,
  I as injectScript,
  d as metaData,
  Q as proDarkThemes,
  R as proLightThemes,
  O as proThemes,
  L as useTheme,
  b as useUrlChangeListener,
  q as zIndices
};
